/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { DeleteReportDefinitionMutationResponse, DeleteReportDefinitionPathParams, DeleteReportDefinition400, DeleteReportDefinition404 } from "../models/DeleteReportDefinition";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteReportDefinition } from "../axios/deleteReportDefinition";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteReportDefinitionMutationKey = () => ["audit-reports-api", { url: '/report-definitions/:id' }] as const

export type DeleteReportDefinitionMutationKey = ReturnType<typeof deleteReportDefinitionMutationKey>

export function deleteReportDefinitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteReportDefinitionMutationKey()
        return mutationOptions<DeleteReportDefinitionMutationResponse, ResponseErrorConfig<DeleteReportDefinition400 | DeleteReportDefinition404>, {id: DeleteReportDefinitionPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return deleteReportDefinition(id, config)
          },
        })

}

/**
 * @description Deletes a report definition by its unique identifier. Cannot delete if it is the only definition for the report type or if it is the default definition.
 * @summary Delete report definition
 * {@link /report-definitions/:id}
 */
export function useDeleteReportDefinition<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteReportDefinitionMutationResponse, ResponseErrorConfig<DeleteReportDefinition400 | DeleteReportDefinition404>, {id: DeleteReportDefinitionPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteReportDefinitionMutationKey()

          const baseOptions = deleteReportDefinitionMutationOptions(config) as UseMutationOptions<DeleteReportDefinitionMutationResponse, ResponseErrorConfig<DeleteReportDefinition400 | DeleteReportDefinition404>, {id: DeleteReportDefinitionPathParams["id"]}, TContext>
          

          return useMutation<DeleteReportDefinitionMutationResponse, ResponseErrorConfig<DeleteReportDefinition400 | DeleteReportDefinition404>, {id: DeleteReportDefinitionPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteReportDefinitionMutationResponse, ResponseErrorConfig<DeleteReportDefinition400 | DeleteReportDefinition404>, {id: DeleteReportDefinitionPathParams["id"]}, TContext>
      
}